/* unplugin-vue-components disabled */import { render } from "./supermap.vue?vue&type=template&id=22be4921&scoped=true"
import script from "./supermap.vue?vue&type=script&lang=js"
export * from "./supermap.vue?vue&type=script&lang=js"

import "./supermap.vue?vue&type=style&index=0&id=22be4921&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22be4921"]])

export default __exports__